<template>
  <div>
    <vx-card>
      <ListVistoriadores
        :subjectPermission="subjectPermission"
      ></ListVistoriadores>
    </vx-card>
  </div>
</template>

<script>
import ListVistoriadores from '../../lists/ListVistoriadores';

export default {
  data() {
    return {
      subjectPermission: 'Vistoriador',
    };
  },
  methods: {},
  components: {
    ListVistoriadores,
  },
};
</script>
